<template>
  <div :class="$style.page">
    <BaseContainer :class="$style.container">
      <form @submit.prevent="submit">
        <BaseLoader
          :class="$style.box"
          :is-active="isFormLoading"
        >
          <FormBox
            :heading="formStepData.heading"
            :lead="formStepData.lead"
          >
            <template v-if="formStep === 1">
              <div :class="$style.renewalSection">
                <h4 :class="$style.renewalHeading">
                  Paid until
                </h4>
                <div :class="$style.renewalDate">
                  <BaseDateInput
                    v-model="paidUntil"
                    :class="$style.dateInput"
                    :model-config="{ timeAdjust: '23:59:59' }"
                  />
                </div>
              </div>
            </template>

            <template #footer>
              <BaseButton
                variant="success"
                type="submit"
                is-block
              >
                {{ formStepData.submitText }}
              </BaseButton>
            </template>
          </FormBox>
        </BaseLoader>
      </form>
    </BaseContainer>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import { mapState } from 'vuex';
import BaseContainer from '@/components/base/Container';
import BaseButton from '@/components/base/Button';
import BaseLoader from '@/components/base/Loader';
import BaseDateInput from '@/components/base/DateInput';
import FormBox from '@/components/FormBox';
import { billingTypes } from '@/config';

export default {
  components: {
    BaseContainer,
    BaseButton,
    BaseLoader,
    BaseDateInput,
    FormBox,
  },
  BILLING_OPTIONS: billingTypes,
  data() {
    return {
      company: null,
      paidUntil: null,
      isFormLoading: false,
      formStep: 1,
    };
  },
  computed: {
    ...mapState('user', ['user']),
    formStepData() {
      if (this.formStep === 1) {
        return {
          heading: `${this.company ? this.company.name : 'Company'} renewal`,
          lead: 'Notes here about doing payments manually, and updating this to reflect what was paid.',
          submitText: 'Save',
        };
      }
      return {
        heading: 'Invoice saved',
        submitText: 'Go to company settings',
      };
    },
  },
  created() {
    this.loadCompany();
  },
  methods: {
    async loadCompany() {
      this.isFormLoading = true;

      const { data } = await this.$apollo.query({
        query: gql`query ($companyId: Int!) {
          companies_by_pk(id: $companyId) {
            id
            name
          }
        }`,
        variables: {
          companyId: this.$route.params.companyId,
        },
        fetchPolicy: 'no-cache',
      });

      this.company = data.companies_by_pk;
      this.isFormLoading = false;
    },
    async saveInvoice() {
      if (this.paidUntil == null) return;

      this.isFormLoading = true;

      await this.$apollo.mutate({
        mutation: gql`mutation ($companyId: Int!, $paidUntil: date!, $createdBy: String!) {
          insert_invoices_one(object: {company_id: $companyId, paid_until: $paidUntil, created_by: $createdBy}) {
            id
          }
        }`,
        variables: {
          companyId: this.$route.params.companyId,
          paidUntil: this.paidUntil,
          createdBy: this.user.username,
        },
      });

      this.isFormLoading = false;
      this.formStep += 1;
    },
    submit() {
      switch (this.formStep) {
        case 1:
          return this.saveInvoice();
        case 2:
          return this.$router.push({ name: 'EditCompany', params: { companyId: this.$route.params.companyId } });
        default:
          return null;
      }
    },
  },
};
</script>

<style lang="scss" module>
.page {
  flex-grow: 1;
  padding-top: map-get($page-vertical-paddings, 'small');
  padding-bottom: map-get($page-vertical-paddings, 'small');
  background: #fafafa;
}

.container {
  display: flex;
  justify-content: center;
}

.box {
  width: 470px;
}

.renewalSection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background: $background-light;
  border-radius: 5px;
}

.renewalHeading {
  margin: 0;
  font-size: 16px;
  color: $title;
}

.renewalDate {
  display: flex;
}

.dateInput {
  width: 250px;
}
</style>
